import React from "react";
import style from "./Modalities.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { Form, MultiSelect } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import { FormActions } from "../../../secondary/FormActions/FormActions";
import { PERMISSIONS } from "../../../../constants/permissions";

export const MultiSelectSectionEditMode = ({
  label,
  fieldId,
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  listResp,
  sectionData,
  listViewRef,
  register,
  onSelectChange,
  onCancelClick,
}) => (
  <div className="mt-3 pt-1">
      <Form setFormChangesConfirm={setFormChangesConfirm} onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.TREATMENT} disabled={!signedLockedAccess(assessmentDetails?.assessmentStage)}>
        <MultiSelect
          id={fieldId}
          name={fieldId}
          label={label}
          classes={{
            column: ` row ${style.botton_spac}`,
            inputClassName: `${style.basic_select}`,
            labelClassName: `col-4 col-form-label ${style.label_spec}`,
            inputColumn: "col-6 p-0",
          }}
          optionValue={Array.isArray(listResp) ? listResp : []}
          showCheckbox={true}
          displayValue="value"
          validator={(e) => {
            register({ required: true });
            listViewRef.current = e;
          }}
          onSelect={onSelectChange}
          onRemove={onSelectChange}
          defaultValue={sectionData ?? []}
          labelSubText="Select all that apply"
        />

        <FormActions
          primaryLabel={SAVE_BTN}
          primaryId="updateBtn"
          primaryType="submit"
          secondaryLabel={CANCEL_BTN}
          secondaryId="cancel"
          onSecondaryClick={onCancelClick}
        />
      </Form>
  </div>
);
